import { useLocation, useParams } from "react-router";
import TransactionItemComponent from "../../components/Transactions/TransactionItem";
import { useTransactionsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";
function TransactionItem(){
    const params = useParams();
    const { data:transaction, error, isLoading } = useTransactionsByIdQuery(params.id??"0");
    const location = useLocation();
    const state = location.state as LocationState | undefined;
        const {translate}=useTrads();
    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
               <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : transaction ? (
            <>
            {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_transaction_update')}</p>}
            <TransactionItemComponent transaction={transaction}  />
            </>
        ):null
    );
}
export default TransactionItem;